import fpApiUtil from "./fp-api-util";

const ANALYSIS = "factoryplan/analysis";

// 품목별 리드타임(공장>품목상위그룹>품목별 LT-bucket 크로스탭) — AnalysisController#getItemLeadTime.
// CustomerLeadTime과 같은 shape(LT-bucket 헤더 1개당 컬럼 1개 flat + `<header>_BASE_LT_FLAG`
// companion 필드). old도 그리드 조회(loadData)/차트 드릴다운(loadChartData) 둘 다 같은 엔드포인트를
// plantCd/itemParentGrpCd/itemCd 필터값만 다르게 호출한다 — postParams만 쓴다(changes는 안 보냄,
// 컬럼 필터 자체가 1차 미이관이라 fp-report-screen-guide.md §A-6e와 동일 결정).
const getItemLeadTimes = (params) => fpApiUtil.postParams(`${ANALYSIS}/item-lead-time`, params);

const fpItemLeadTimeService = { getItemLeadTimes };
export default fpItemLeadTimeService;
